import React, { useRef, useEffect } from 'react'
import * as THREE from 'three'
import { BakeShadows, useHelper, Sky, CameraControls } from '@react-three/drei'
import { Perf } from 'r3f-perf'
import { useFrame } from '@react-three/fiber'

import BaseModel from '../baseModel'

export default function Experience() {
    const directionalLightRef = useRef(null)
    // @ts-ignore
    // useHelper(directionalLightRef, THREE.DirectionalLightHelper, 1)
    const floorLampLightRef = useRef(null)
    // @ts-ignore
    // useHelper(floorLampLightRef, THREE.PointLightHelper, 1)
    const orbitControlsRef = useRef(null)
    useEffect(() => {
        if (orbitControlsRef.current) {

        }
    }, [orbitControlsRef.current])

    useFrame((state) => {
        state.camera.lookAt(1, 4, 1)
    })

    return <>
        <CameraControls
            minAzimuthAngle={-Math.PI / 2}
            maxAzimuthAngle={Math.PI / 8 - 0.4}
            minPolarAngle={Math.PI / 6}
            maxPolarAngle={Math.PI - Math.PI / 2}
            maxDistance={40}
            minDistance={20}
        />
        <BakeShadows />
        {/* <Perf position="top-left" /> */}
        <directionalLight
            ref={directionalLightRef}
            castShadow
            position={[0, 0.1, 0]}
            intensity={1} />
        <ambientLight intensity={0.5} />
        <pointLight
            castShadow
            position={[1.1, 2, -0.7]}
            intensity={5.5}
            color="orange"
        />
        <pointLight
            ref={floorLampLightRef}
            castShadow
            position={[4.8, 3, 2.6]}
            intensity={6.5}
            color="#fcc"
        />
        <Sky
            inclination={0.5}
            azimuth={0.4}
            turbidity={20}
            rayleigh={3}
            mieCoefficient={0.005}
            mieDirectionalG={0.8}
        />

        {/* <Floor />
        <LeftWall />
        <RightWall /> */}

        {/* <axesHelper args={[10]} /> */}
        <BaseModel castShadow position={[0, 0, 0]} />
    </>
} 
